import { gql } from '@apollo/client'

export default gql`
  mutation archiveUsers($userIds: [ID]!, $organizationId: ID!) {
    archiveUsers(userIds: $userIds, organizationId: $organizationId)
  }
`
